import { useExperienceData } from './ExperienceDataContext';

/**
 * Custom hook for accessing Monarch experience variants.
 *
 * This hook provides a simplified interface to work with experience variants from the Monarch system.
 * It extracts variant information from the experience data context and provides utilities for checking
 * variant states.
 *
 * hasVariant accepts the component ID value and returns true/false if that ID is in the experience variant/asset array
 */

export interface ExperienceValue {
  value?: {
    componentCustomId: string;
    componentId: string;
    componentName: string;
  };
}

export function useExperienceVariants() {
  const experienceData = useExperienceData();

  const variants =
    experienceData?.experienceValues
      ?.map((value: ExperienceValue) => value?.value?.componentId)
      .filter(Boolean) || [];

  const hasVariant = (componentId: string) => variants.includes(componentId);

  return {
    variants,
    hasVariant,
  };
}
